export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se requiere confirmación"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La autorización debe ser confirmada con una clave de un solo uso"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La autorización debe ser confirmada con una palabra mágica"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El registro debe ser confirmado con un código de mensaje de texto"])}
}